var map = {
	"./index.routes.js": "HzYv",
	"./login.routes.js": "J8jm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jGQ1";


//////////////////
// WEBPACK FOOTER
// ./src/router \.routes\.js
// module id = jGQ1
// module chunks = 17